// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const Link = t.struct({
    label: t.String,
    location: t.String,
    url: t.String
}, {
    name: 'Link',
    strict: true
});

export const getDefaultState = () => new Link({
    label: '',
    location: '',
    url: ''
});

export default Link;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/link.js